import angular from 'angular';
import $ from 'jquery';
import _ from 'underscore';

export default class BuyerSpecialPricings {
  constructor($scope, ProductService, GeoService, UserService) {
    $scope.parseInt = function(value) {
      return parseInt(value);
    };

    $scope.tabs = [
      {
        title: 'Product Prices',
        items: [],
        count: 0
      },
      {
        title: 'Price Group Prices',
        items: [],
        count: 0
      },
      {
        title: 'Check Product Prices',
        items: [],
        count: 0
      },
      {
        title: 'Check Price Group Prices',
        items: [],
        count: 0
      }
    ];

    $scope.set_selected_tab = function(index) {
      $scope.selected_tab = index;
    };

    $scope.$watch('pricing.shipment_country_id', function() {
      if ($scope.pricing && $scope.pricing.shipment_country_id) {
        GeoService.get_cities($scope.pricing.shipment_country_id).then(function(data) {
          $scope.shipment_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.pricing.shipment_city_id}))
            $scope.pricing.shipment_city_id = null;
        });
      }
    });

    $scope.$watch('pricing.delivery_country_id', function() {
      if ($scope.pricing && $scope.pricing.delivery_country_id) {
        GeoService.get_cities($scope.pricing.delivery_country_id).then(function(data) {
          $scope.delivery_cities = data.cities;
          if (!_.findWhere(data.cities, {id: $scope.pricing.delivery_city_id}))
            $scope.pricing.delivery_city_id = null;
        });
      }
    });

    $scope.$watch('pricing.product_id', function() {
      if ($scope.pricing && $scope.pricing.product_id) {
        var product = _.findWhere($scope.products, {
          id: $scope.pricing.product_id
        });
        if (product)
          $scope.load_product_group_ranges(product.product_group_id);
      }
    });

    $scope.$watch('pricing.product_price_group_id', function() {
      if ($scope.pricing && $scope.pricing.product_price_group_id) {
        var price_group = _.findWhere($scope.price_groups, {
          id: $scope.pricing.product_price_group_id
        });
        if (price_group)
          $scope.load_product_group_ranges(price_group.product_group_id);
      }
    });

    $scope.set_user_autocomplete = function(input) {
      input.autocomplete({
        delay: 300,
        source: function(request, response) {
          UserService.search_by_company('Buyer', request.term).then(function(data) {
            response(data.users);
          });
        },
        select: function(event, ui) {
          $scope.pricing.buyer_id = ui.item.id;
          $scope.buyer_user_company = ui.item.value;
          $(this).val('');
          $scope.$apply();
          if ($scope.mode === 0)
            $scope.load_buyer_products(ui.item.id);
          else
            $scope.load_buyer_price_groups(ui.item.id);
        }
      });
    };

    $scope.load_buyer_products = function(user_id) {
      UserService.get_buyer_preference_products(user_id).success(function(data) {
        $scope.products = data.products;
        if (!_.findWhere(data.products, {id: $scope.pricing.product_id}))
          $scope.pricing.product_id = null;
        if ($scope.pricing.product_id) {
          var product = _.findWhere($scope.products, {
            id: $scope.pricing.product_id
          });
          $scope.load_product_group_ranges(product.product_group_id);
        }
      });
    };

    $scope.load_buyer_price_groups = function(user_id) {
      UserService.get_buyer_preference_price_groups(user_id).success(function(data) {
        $scope.price_groups = data.price_groups;
        if (!_.findWhere(data.price_groups, {id: $scope.pricing.product_price_group_id}))
          $scope.pricing.product_price_group_id = null;
        if ($scope.pricing.product_price_group_id) {
          var price_group = _.findWhere($scope.price_groups, {
            id: $scope.pricing.product_price_group_id
          });
          $scope.load_product_group_ranges(price_group.product_group_id);
        }
      });
    };

    $scope.load_product_group_ranges = function(product_group_id) {
      ProductService.get_product_group_ranges(product_group_id, $scope.pricing.is_reels).success(function(data) {
        $scope.ranges = data.ranges;
        if (!_.findWhere($scope.ranges, {id: $scope.pricing.range_id}))
          $scope.pricing.range_id = null;
      });
    };

    $scope.remove_user = function() {
      $scope.pricing.buyer_id = null;
      $scope.buyer_user_company = null;
      $('input.user_company').val('');
      if ($scope.mode === 0) {
        $scope.pricing.product_id = null;
        $scope.products = [];
      } else {
        $scope.pricing.product_price_group_id = null;
        $scope.price_groups = [];
      }
      $scope.range_id = null;
      $scope.ranges = [];
    };

    $scope.get_range_label = function(range) {
      var label = 'Substance: ' + range.substance_min + ' - ' + range.substance_max;
      if ($scope.pricing.is_reels)
        label = label + ', Range: ' + range.rw_min + ' - ' + range.rw_max;
      return label;
    };

    $scope.load_prices = function() {
      $scope.loading = true;
      UserService.get_buyer_prices(window.user_id).success(function(data) {
        $scope.set_products(data.product_prices);
        $scope.set_price_groups(data.price_group_prices);
        $scope.product_users = data.product_users;
        $scope.price_group_users = data.price_group_users;
        $scope.loading = false;
      });
    };

    $scope.set_products = function(prices) {
      var default_prices = _.where(prices, {
        check_manual: false
      });
      var check_prices = _.where(prices, {
        check_manual: true
      });
      $scope.tabs[0].count = default_prices.length;
      $scope.tabs[2].count = check_prices.length;
      if (window.user_type == 'Buyer') {
        $scope.tabs[0].items = _.groupBy(default_prices, 'supplier_id');
        $scope.tabs[2].items = _.groupBy(check_prices, 'supplier_id');
      } else {
        $scope.tabs[0].items = _.groupBy(default_prices, 'buyer_id');
        $scope.tabs[2].items = _.groupBy(check_prices, 'buyer_id');
      }
    };

    $scope.set_price_groups = function(prices) {
      var default_prices = _.where(prices, {
        check_manual: false
      });
      var check_prices = _.where(prices, {
        check_manual: true
      });
      $scope.tabs[1].count = default_prices.length;
      $scope.tabs[3].count = check_prices.length;
      if (window.user_type == 'Buyer') {
        $scope.tabs[1].items = _.groupBy(default_prices, 'supplier_id');
        $scope.tabs[3].items = _.groupBy(check_prices, 'supplier_id');
      } else {
        $scope.tabs[1].items = _.groupBy(default_prices, 'buyer_id');
        $scope.tabs[3].items = _.groupBy(check_prices, 'buyer_id');
      }
    };

    $scope.save_price = function() {
      if (!$scope.pricing.buyer_id) {
        alert('Please select a buyer!');
      } else if ($scope.mode === 0 && !$scope.pricing.product_id) {
        alert('Please select a product!');
      } else if ($scope.mode === 1 && !$scope.pricing.product_price_group_id) {
        alert('Please select a price group!');
      } else {
        $scope.saving_pricing = true;
        UserService.save_buyer_price($scope.mode, $scope.pricing).success(function(data) {
          if (data.success) {
            $scope.saving_pricing = false;
            $.fancybox.close();
            $scope.load_prices();
          }
        });
      }
    };

    $scope.add_price = function(mode) {
      $scope.mode = mode;
      if ($scope.mode === 0) {
        $scope.products = [];
        $scope.pricing = angular.copy(window.product_price);
      } else {
        $scope.price_groups = [];
        $scope.pricing = angular.copy(window.price_group_price);
      }
      $scope.range_id = null;
      $scope.ranges = [];
      $scope.buyer_user_company = null;
      $('input.user_company').val('');
      window.openFancyboxDialog('div#pricing_dialog');
    };

    $scope.edit_price = function(mode, price) {
      $scope.pricing = {
        id: price.id,
        buyer_id: price.buyer_id,
        supplier_id: price.supplier_id,
        range_id: price.range_id,
        delivery_term_id: price.delivery_term_id,
        delivery_country_id: price.delivery_country_id,
        delivery_city_id: price.delivery_city_id,
        shipment_term_id: price.shipment_term_id,
        shipment_country_id: price.shipment_country_id,
        shipment_city_id: price.shipment_city_id,
        currency_id: price.currency_id,
        price: price.price,
        charge: price.charge,
        price_date: price.price_date,
        admin_expire_date: price.admin_expire_date,
        auto_activation: price.auto_activation,
        is_reels: price.is_reels
      };
      $scope.mode = mode;
      if ($scope.mode === 0) {
        $scope.pricing.product_id = price.product_id;
        $scope.products = [];
        $scope.load_buyer_products(price.buyer_id);
      } else {
        $scope.pricing.product_price_group_id = price.product_price_group_id;
        $scope.price_groups = [];
        $scope.load_buyer_price_groups(price.buyer_id);
      }
      $scope.buyer_user_company = price.buyer_name;
      $scope.range_id = null;
      $scope.ranges = [];
      window.openFancyboxDialog('div#pricing_dialog');
    };

    $scope.delete_product_price = function(price_id) {
      if (confirm('Are you sure you want to delete this pricing?')) {
        UserService.delete_buyer_product_price(price_id).success(function(data) {
          if (data.success)
            $scope.load_prices();
        });
      }
    };

    $scope.delete_price_group_price = function(price_id) {
      if (confirm('Are you sure you want to delete this pricing?')) {
        UserService.delete_buyer_price_group_price(price_id).success(function(data) {
          if (data.success)
            $scope.load_prices();
        });
      }
    };

    $scope.delivery_terms = [
      {
        id: 3,
        title: 'FCA'
      },
      {
        id: 1,
        title: 'CFR'
      },
      {
        id: 2,
        title: 'DAP'
      }
    ];

    $scope.date_options = {
      changeMonth: true,
      changeYear: true,
      dateFormat: 'dd/mm/yy'
    };

    $scope.item_modes = [
      {
        title: 'Reels',
        value: true
      },
      {
        title: 'Sheets',
        value: false
      }
    ];

    $scope.selected_tab = 0;
    $scope._ = _;
    $scope.products = [];
    $scope.price_groups = [];
    $scope.ranges = [];
    $scope.countries = window.countries;
    $scope.set_user_autocomplete($('input.user_company'));
    $scope.user_type = window.user_type;
    $scope.load_prices();
  }
}

BuyerSpecialPricings.$inject = ['$scope', 'ProductService', 'GeoService', 'UserService'];



// WEBPACK FOOTER //
// ./front/js/admin/controllers/buyer-special-pricings.ctrl.js